import styled from 'styled-components';

export const ColorTile = styled.div<{
  color: string;
  label: string;
}>`
  background-color: ${(props) => props.color};
  display: block;
  height: 100px;
  width: 100px;
  border-radius: 5px;
  margin-right: 40px;
  border: ${(props) =>
    props.label === 'White' || props.label === 'N0'
      ? `1px solid ${props.theme.newPalette.neutral.N400}`
      : 0};
`;

export const ColorBlockContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 640px;
  justify-content: flex-start;
  margin-bottom: 40px;
`;

export const ColorDetailsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 500px;
  align-items: center;
`;
